module.exports = __webpack_public_path__ + "img/details.63c06044.svg";